import React, { FunctionComponent as FC, useContext } from 'react';
import { PietroskiButton } from './styled';
import { OnSubmitContext, FormPropsContext } from '..';

export interface ButtonProps {
    type?: string;
    textValue?: string;
    width?: string;
    minHeight?: string;
    margin?: string;
    padding?: string;
    border?: string;
    borderRadius?: string;
    backgroundColor?: string;
    boxShadow?: string;
    fontSize?: string;
    onClick?: (e: any) => void
}

const Button: FC<ButtonProps> = (props: ButtonProps) => {

    const {textValue} = props;
    const useOnSubmit = useContext(OnSubmitContext);
    const {darkMode} = useContext(FormPropsContext);

    return (
        <PietroskiButton onClick={(e: any) => {e.preventDefault(); useOnSubmit && useOnSubmit()}} {...props} darkMode={darkMode} >
            {textValue}
        </PietroskiButton>
    )
}

export default Button;